import {
  GET_USER_FOLDERS_REQUEST,
  GET_USER_FOLDERS_SUCCESS,
  GET_USER_FOLDERS_FAIL,
  GET_ONE_USER_FOLDER_REQUEST,
  GET_ONE_USER_FOLDER_SUCCESS,
  GET_ONE_USER_FOLDER_FAIL,
  CREATE_USER_FOLDER_REQUEST,
  CREATE_USER_FOLDER_SUCCESS,
  CREATE_USER_FOLDER_FAIL,
  UPDATE_USER_FOLDER_REQUEST,
  UPDATE_USER_FOLDER_SUCCESS,
  UPDATE_USER_FOLDER_FAIL,
  DELETE_USER_FOLDER_REQUEST,
  DELETE_USER_FOLDER_SUCCESS,
  DELETE_USER_FOLDER_FAIL,
  ATTACH_PRODUCT_REQUEST,
  ATTACH_PRODUCT_SUCCESS,
  ATTACH_PRODUCT_FAIL,
  DETACH_PRODUCT_REQUEST,
  DETACH_PRODUCT_SUCCESS,
  DETACH_PRODUCT_FAIL,
} from "./types";
import UserFoldersServices from "./services";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";

export const getAllUserFolders = () => async (dispatch: any) => {
  dispatch({ type: GET_USER_FOLDERS_REQUEST });
  try {
    const response = await UserFoldersServices.getAllUserFolders();
    dispatch({ type: GET_USER_FOLDERS_SUCCESS, payload: response.data });
  } catch (error: any) {
    dispatch({ type: GET_USER_FOLDERS_FAIL, payload: error.response });
  }
};

export const getOneUserFolder = (id: any) => async (dispatch: any) => {
  dispatch({ type: GET_ONE_USER_FOLDER_REQUEST });
  try {
    const response = await UserFoldersServices.getOneUserFolder(id);
    dispatch({ type: GET_ONE_USER_FOLDER_SUCCESS, payload: response.data });
  } catch (error: any) {
    dispatch({ type: GET_ONE_USER_FOLDER_FAIL, payload: error.response });
  }
};

export const createUserFolder = (data: any) => async (dispatch: any) => {
  dispatch({ type: CREATE_USER_FOLDER_REQUEST });
  try {
    const response = await UserFoldersServices.createUserFolder(data);
    dispatch({ type: CREATE_USER_FOLDER_SUCCESS, payload: response.data });
    dispatch(getAllUserFolders());
    MyNotif("Collection created successfully", "success");
  } catch (error: any) {
    dispatch({ type: CREATE_USER_FOLDER_FAIL, payload: error.response });
  }
};

export const updateUserFolder = (id: any, data: any) => async (dispatch: any) => {
  dispatch({ type: UPDATE_USER_FOLDER_REQUEST });
  try {
    const response = await UserFoldersServices.updateUserFolder(id, data);
    dispatch({ type: UPDATE_USER_FOLDER_SUCCESS, payload: response.data });
    dispatch(getAllUserFolders());
    MyNotif("Collection updated successfully", "success");
  } catch (error: any) {
    dispatch({ type: UPDATE_USER_FOLDER_FAIL, payload: error.response });
  }
};

export const deleteUserFolder = (id: any) => async (dispatch: any) => {
  dispatch({ type: DELETE_USER_FOLDER_REQUEST });
  try {
    const response = await UserFoldersServices.deleteUserFolder(id);
    dispatch({ type: DELETE_USER_FOLDER_SUCCESS, payload: id });
    dispatch(getAllUserFolders());
    MyNotif("Collection deleted successfully", "success");
  } catch (error: any) {
    dispatch({ type: DELETE_USER_FOLDER_FAIL, payload: error.response });
  }
};

export const attachProductToFolder = (folderId: any, productId: any) => async (dispatch: any) => {
  dispatch({ type: ATTACH_PRODUCT_REQUEST });
  try {
    const response = await UserFoldersServices.attachProductToFolder(folderId, productId);
    dispatch({ type: ATTACH_PRODUCT_SUCCESS, payload: response.data });
    dispatch(getAllUserFolders());
    MyNotif("Product added to collection", "success");
  } catch (error: any) {
    dispatch({ type: ATTACH_PRODUCT_FAIL, payload: error.response });
    MyNotif(error.response?.data?.message || "Failed to add product to collection", "error");
  }
};

export const detachProductFromFolder = (folderId: any, productId: any) => async (dispatch: any) => {
  dispatch({ type: DETACH_PRODUCT_REQUEST });
  try {
    const response = await UserFoldersServices.detachProductFromFolder(folderId, productId);
    dispatch({ type: DETACH_PRODUCT_SUCCESS, payload: response.data });
    dispatch(getAllUserFolders());
    MyNotif("Product removed from collection", "success");
  } catch (error: any) {
    dispatch({ type: DETACH_PRODUCT_FAIL, payload: error.response });
    MyNotif(error.response?.data?.message || "Failed to remove product from collection", "error");
  }
};
